<template>
  <notification
    type="is-danger"
    icon="fa-exclamation-circle"
    @delete="$emit('delete')"
  >
    Podjęta została próba logowania z użyciem nieprawidłowego tokenu. Kolejne
    tego typu próby mogą skutkować zablokowaniem urządzenia.
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "invalid-exchange-token-notification",

  components: {
    Notification
  }
};
</script>

<style></style>
